/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from "react";
import { useQuery } from "@apollo/client";
import { GET_ORDERS } from "../../queries";
import { withTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import { useThemeData } from "../../context/ThemeDataContext";
import { useAuthData } from '../../context/AuthProvider';
import { usePhotoBaseData } from '../../context/PhotoBasicDataContext';

function SharePhotosComponent(props) {
  const { site_id } = useThemeData().themeData.site;
  const { user_id } = usePhotoBaseData().photoDefaultSettings;
  const PHOTO_URL = process.env.REACT_APP_PHOTO_URL;
  const APP_URL = process.env.REACT_APP_SITE_URL;
  const { login_name } = useAuthData();
  const file_path = `${PHOTO_URL}${site_id}`

  const {
    loading: loadingOrders,
    error: errorOrders,
    data: dataOrders,
  } = useQuery(GET_ORDERS, {
    variables: {
      user_id: user_id,
      site_id: site_id,
      sfg_login_code: login_name,
    },
    skip: !login_name || !site_id || !user_id
  });

  if (loadingOrders) return <p>{props.t("Loading...")}</p>;
  if (errorOrders) return <p>{props.t("Looks like we have a problem...")}</p>;
  if (!dataOrders) return null;

  return (
    <Grid item lg={12} md={12} className="top-form">
      <p className="font-bold no-margin-bttm">{props.t('checkout:Facebook')}</p>
      <p>{props.t('checkout:Link Explained')}</p>
      <Grid container spacing={1} direction="row" className="justify-content-center">
        {dataOrders.getOrder.map((o) => {
          
            const product_combivel_id = o.product_combivel_id === undefined ? 0 : o.product_combivel_id;
            const product_effect_id = o.product_effect_id === undefined ? 0 : o.product_effect_id;

          return <Grid item xs={6} sm={3} md={2} className="text-center bottom-card" key={o.bestelling_regel_id}>
            <a
              target="_black"
              href={
                `https://www.facebook.com/sharer/sharer.php?u=${file_path}/${o.folder_id}/0/0/0/0/${o.foto_id}/${o.afbeelding_bestand}&picture=${file_path}/${o.folder_id}/0/0/0/0/${o.foto_id}/${o.afbeelding_bestand}&image=${file_path}/${o.folder_id}/${product_combivel_id}/${product_effect_id}/0/${o.foto_id}/${o.afbeelding_bestand}&title=${file_path}/${o.folder_id}/${product_combivel_id}/${product_effect_id}/0/${o.foto_id}/${o.afbeelding_bestand}&quote=${file_path}/${o.folder_id}/${product_combivel_id}/${product_effect_id}/0/${o.foto_id}/${o.afbeelding_bestand}&description=${file_path}/${o.folder_id}/${product_combivel_id}/${product_effect_id}/0/${o.foto_id}/${o.afbeelding_bestand}`
              }
            >
              <img
                src={`${file_path}/${o.folder_id}/0/0/0/0/${o.foto_id}/${o.afbeelding_bestand}`}
                style={{
                  background: `url(${APP_URL}${site_id}/userfiles/effecten/${o.afbeelding_bestand}) no-repeat`,
                  backgroundSize: "cover",
                }}
                alt={o.afbeelding_bestand}
                className="image small-image-size"
              />
            </a>
            </Grid>

          })}
      </Grid>
    </Grid>
  );
}

export default React.memo(withTranslation(["message", "checkout"])(SharePhotosComponent));
